
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Кабинет', path: '/settings/cabinet' },
            { id: 2, name: 'Уведомления', path: '/settings/notifications' },
            { id: 3, name: 'Уведомления для IT', path: '/settings/notifications-it' },
            { id: 4, name: 'Типы договоров', path: '/settings/contract-types' },
            { id: 5, name: 'Шаблоны WABA', path: '/settings/waba' }
        ]

        return { tabs }
    },
})
